import React from 'react';
import '../styles/Tabs.css';


const TABS = [
  { id: 'descripcion', label: 'Descripción' },
  { id: 'rutas', label: 'Rutas' },
  { id: 'servicios', label: 'Servicios' },
  { id: 'almacenamiento', label: 'Almacenamiento'}
];

export default function Tabs({ activeTab, onTabClick }) {
  return (
    <nav className="tabs-nav-container">
      {TABS.map(tab => (
        <button
          key={tab.id}
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`tab-item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabClick(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}